<script>
import router from "../../router";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  name: "AddAccessRight",
  components: { DatePicker, VueTimepicker },
  data() {
    return {
      clock_date: "",
      clock_time: "",
      start_date: "",
      end_date: "",
      hours: "",
      start_time: "",
      datetime1: "",
      datetime2: "",
      end_time: "",
      storeList: [],
      employeeList: [],
      time_card: {
        id: null,
        employee_id: "",
        store_id: "",
        clock_in_date: "",
        clock_out_date: "",
        clock_in_time: "",
        clock_out_time: "",
        timecard_status: "OPEN"
      },
      total_hours: ""
    };
  },
  methods: {
    details(id) {
      this.time_card = {};

      this.$api
        .getAPI({
          _action: "/time_card/detail/" + id
        })
        .then(res => {
          this.time_card = res;
          this.getEmployeeList(res.employee_id);
          if (res.clock_in_date) {
            this.start_date = new Date(res.clock_in_date);
            this.start_time = moment(res.clock_in_date).format("HH:mm");
          }

          if (res.clock_out_date) {
            this.end_date = new Date(res.clock_out_date);
            this.end_time = moment(res.clock_out_date).format("HH:mm");
          }
          this.calculatehours(res.clock_out_date, res.clock_in_date);
        });
    },
    save() {
      this.$api
        .postAPI({
          _action: "/time_card/",
          _body: this.time_card,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });

          router.push("/time-card");
        })
        .catch(e => {});
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },
    getClockOutDate() {
      this.clock_in_date = moment(String(this.start_date)).format("YYYY-DD-MM");
      this.clock_out_date = moment(String(this.end_date)).format("YYYY-DD-MM");
      var date1 = this.start_date;
      var date2 = this.end_date;
      var valid_start_date = moment(date1, "YYYY-DD-MM", true);
      var valid_end_date = moment(date2, "YYYY-DD-MM", true);

      if (valid_start_date.isValid() && valid_end_date.isValid()) {
        if (valid_end_date.isBefore(valid_start_date)) {
          this.clock_out_date = "";
          this.end_date = "";
          this.total_hours = "";
          this.$notify({
            group: "foo",
            text: this.$lang.messages.must_not_earlier_than_clock_time,
            type: "error"
          });
          return false;
        }
      }
      this.getClockOutTime();
    },

    getClockOutTime() {
      this.startDate = moment(String(this.start_date)).format("YYYY-DD-MM");
      this.endDate = moment(String(this.end_date)).format("YYYY-DD-MM");
      var date1 = this.startDate + " " + this.start_time;
      var date2 = this.endDate + " " + this.end_time;
      var valid_start_date = moment(date1, "YYYY-DD-MM HH:mm", true);
      var valid_end_date = moment(date2, "YYYY-DD-MM HH:mm", true);
      if (valid_start_date.isValid() && valid_end_date.isValid()) {
        if (valid_end_date.isBefore(valid_start_date)) {
          this.end_time = "";
          this.clock_out_time = "";
          this.total_hours = "";
          this.$notify({
            group: "foo",
            text: this.$lang.messages.must_not_earlier_than_clock_time,
            type: "error"
          });
          return false;
        }

        this.time_card.clock_in_date = moment.utc(
          moment(date1, "YYYY-DD-MM HH:mm")
            .utc()
            .format("YYYY-MM-DD HH:mm:ssZ")
        );

        this.time_card.clock_out_date = moment.utc(
          moment(date2, "YYYY-DD-MM HH:mm")
            .utc()
            .format("YYYY-MM-DD HH:mm:ssZ")
        );
        this.calculatehours(
          this.time_card.clock_out_date,
          this.time_card.clock_in_date
        );
      }
    },
    calculatehours(clock_out_date, clock_in_date) {
      if (clock_out_date && clock_in_date){
        var duration = moment.duration(clock_out_date.diff(clock_in_date));
        var hours = parseInt(duration.asHours());
        var minutes = parseInt(duration.asMinutes()) % 60;

        if (minutes > 0) {
          this.total_hours = hours + " : " + minutes;
        } else {
          this.total_hours = hours;
        }
      } else {
        this.total_hours = ''
      }
      
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    getEmployeeList(employee_id) {
      this.employeeList = []
      this.time_card.employee_id = ""
      if (this.time_card.store_id == ""){
        return
      }
      this.$api
        .getAPI(
          { 
            _action: `/employee/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`,
            _body: {
              store_id: this.time_card.store_id
            } 
          })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.employeeList = res.list;
          }
          if (employee_id){
            this.time_card.employee_id = employee_id;
          }
        })
        .catch(e => {});
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
    this.getStoreList();
    this.start_date = new Date();
    this.end_date = new Date();
  }
};
</script>
<style>
.vue__time-picker input.display-time {
  border: 1px solid #d2d2d2;
  width: 22.5em;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;
}
</style>
<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-9">
          <div class="card rounded-5 p-3 border">
            <div class="card-body form-style">
              <div class="row mb-4">
                <div class="col-lg-6">
                  <label for>{{$lang.messages.store}}</label>
                  <span style="color:#ff0000">*</span>
                  <select
                    v-model="time_card.store_id"
                    class="form-control"
                    :class="{ 'is-danger': errors.has('store_id')}"
                    v-validate="'required'"
                    name="store_id"
                    @change="getEmployeeList()"
                  >
                    <option value>{{$lang.messages.select_store}}</option>
                    <option
                      v-for="store in storeList"
                      :key="store.id"
                      :value="store.id"
                      v-validate="'required'"
                    >{{store.name}}</option>
                  </select>
                  <i v-show="errors.has('store_id')" class="fa fa-warning"></i>
                  <span v-show="errors.has('store_id')" class="help is-danger">{{$lang.messages.please_select_store}}</span>
                </div>

                <div class="col-lg-6">
                  <label for>{{$lang.messages.employee_name}}</label>
                  <span style="color:#ff0000">*</span>
                  <select
                    v-model="time_card.employee_id"
                    class="form-control"
                    :class="{ 'is-danger': errors.has('employee_id')}"
                    v-validate="'required'"
                    name="employee_id"
                  >
                    <option value>{{$lang.messages.select_employee}}</option>
                    <option
                      v-for="employee in employeeList"
                      :key="employee.id"
                      :value="employee.id"
                    >{{employee.name}}</option>
                  </select>
                  <i v-show="errors.has('employee_id')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('employee_id')"
                    class="help is-danger"
                  >{{$lang.messages.please_select_employee}}</span>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-lg-6">
                  <label for>{{$lang.messages.clock_in_date}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="input-group">
                    <date-picker
                      v-model="start_date"
                      format="YYYY-DD-MM"
                      value="2019-29-10"
                      style="width:400px;"
                      v-validate="'required'"
                      :class="{'is-danger': errors.has('clock_in_date') }"
                      name="startdate"
                      @change="getClockOutDate()"
                    ></date-picker>

                    <i v-show="errors.has('startdate')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('startdate')"
                      class="help is-danger"
                    >{{$lang.messages.please_select_clock_in_date}}</span>
                  </div>
                </div>
                <div class="col-lg-6">
                  <label for>{{$lang.messages.clock_out_date}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="input-group">
                    <date-picker
                      v-model="end_date"
                      format="YYYY-DD-MM"
                      style="width:400px;"
                      v-validate="'required'"
                      name="end_date"
                      :class="{'is-danger': errors.has('clock_out_date') }"
                      @change="getClockOutDate()"
                    ></date-picker>
                    <i v-show="errors.has('end_date')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('end_date')"
                      class="help is-danger"
                    >{{$lang.messages.please_select_clock_out_date}}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-lg-6">
                  <label for>{{$lang.messages.clock_in_time}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="input-group">
                    <vue-timepicker
                      v-model="start_time"
                      :placeholder="$lang.messages.start_time"
                      format="HH:mm"
                      style="width:350%"
                      v-validate="'required'"
                      name="start_time"
                      @change="getClockOutTime()"
                    ></vue-timepicker>
                    <i v-show="errors.has('start_time')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('start_time')"
                      class="help is-danger"
                    >{{$lang.messages.please_select_clock_in_time}}</span>
                  </div>
                </div>
                <div class="col-lg-6">
                  <label for>{{$lang.messages.clock_out_time}}</label>
                  <span style="color:#ff0000">*</span>
                  <div class="input-group">
                    <vue-timepicker
                      v-model="end_time"
                      :placeholder="$lang.messages.end_time"
                      format="HH:mm"
                      style="width:350%"
                      v-validate="'required'"
                      name="end_time"
                      @change="getClockOutTime()"
                    ></vue-timepicker>
                    <i v-show="errors.has('end_time')" class="fa fa-warning"></i>
                    <span
                      v-show="errors.has('end_time')"
                      class="help is-danger"
                    >{{$lang.messages.please_select_clock_out_time}}</span>
                  </div>
                </div>
                <div class="col-lg-12 mt-5">
                  <p class="font-20">{{$lang.messages.total_hours}}: {{total_hours}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-9 text-right">
          <button
            type="button"
            class="btn btn-primary mr-3"
            @click="validateForm()"
            id="save-btn"
          >{{$lang.messages.save_btn_text}}</button>
          <button
            type="submit"
            class="btn btn-outline-primary mt-lg-0 mt-3"
            @click="$router.go(-1)"
          >{{$lang.messages.cancel_btn_text}}</button>
        </div>
      </div>
    </div>
  </div>
</template>